<app-empty-state
  (actionClick)="currOption?.actionClick()"
  [title]="'Nothing to see, yet!'"
  [subtitle]="currOption?.subtitle"
  [buttonText]="currOption?.buttonText"
  [icon]="icon"
  [isLauncher]="isLauncher"
></app-empty-state>
